import { ZfDialogFooter, ZfLoadingSpinner, ZfStack, ZfTextButton } from '@zafire/react';
import React from 'react';
import { SaveBlockedTooltip } from '../../SaveBlockedTooltip';

export type ConfigureProductModalFooterProps = {
  canSave: boolean;
  isPending: boolean;
  saveBlockedReasons: string[];
  onSave?: () => Promise<void>;
  onClose: () => void;
  showSave?: boolean;
  closeLabel?: string;
};

export const ConfigureProductModalFooter: React.FC<ConfigureProductModalFooterProps> = ({
  canSave,
  isPending,
  saveBlockedReasons,
  onSave,
  onClose,
  showSave = true,
  closeLabel = 'Cancel',
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

  return (
    <ZfDialogFooter>
      <ZfStack slot="primary" direction="row" spacing="small">
        <ZfTextButton
          hierarchy="tertiary"
          size="small"
          onClick={onClose}
          id="remove-product-cancel-button"
          data-testid="remove-product-cancel-button"
          disabled={isPending}
        >
          {closeLabel}
        </ZfTextButton>
        {showSave && (
          <div ref={setAnchorEl} data-testid="product-config-save-button-wrapper" style={{ pointerEvents: 'auto' }}>
            <ZfTextButton
              hierarchy="primary"
              size="small"
              disabled={!canSave || isPending}
              id="product-config-save-button"
              data-testid="product-config-save-button"
              onClick={onSave}
            >
              {isPending && <ZfLoadingSpinner size="extra-small" />}
              Save
            </ZfTextButton>
            <SaveBlockedTooltip reasons={saveBlockedReasons} anchorEl={anchorEl} />
          </div>
        )}
      </ZfStack>
    </ZfDialogFooter>
  );
};
